import { useEffect } from "react";

/**
 * FORTRESS-LEVEL SecurityHeaders component
 * Implements comprehensive client-side security headers
 */
export const SecurityHeaders = () => {
  useEffect(() => {
    // Strict Content Security Policy
    const cspMeta = document.createElement("meta");
    cspMeta.httpEquiv = "Content-Security-Policy";
    cspMeta.content = [
      "default-src 'self'",
      "script-src 'self' 'unsafe-inline' 'unsafe-eval'",
      "style-src 'self' 'unsafe-inline'",
      "img-src 'self' data: https: blob:",
      "font-src 'self' data:",
      "connect-src 'self' https://*.supabase.co wss://*.supabase.co https://ai.gateway.lovable.dev",
      "frame-ancestors 'none'",
      "base-uri 'self'",
      "form-action 'self'",
      "upgrade-insecure-requests"
    ].join("; ");
    
    // Strict referrer policy
    const referrerMeta = document.createElement("meta");
    referrerMeta.name = "referrer";
    referrerMeta.content = "strict-origin-when-cross-origin";
    
    // X-Content-Type-Options
    const contentTypeMeta = document.createElement("meta");
    contentTypeMeta.httpEquiv = "X-Content-Type-Options";
    contentTypeMeta.content = "nosniff";
    
    // Permissions Policy (formerly Feature Policy)
    const permissionsMeta = document.createElement("meta");
    permissionsMeta.httpEquiv = "Permissions-Policy";
    permissionsMeta.content = "geolocation=(), microphone=(), camera=(), payment=()";

    document.head.appendChild(cspMeta);
    document.head.appendChild(referrerMeta);
    document.head.appendChild(contentTypeMeta);
    document.head.appendChild(permissionsMeta);

    return () => {
      document.head.removeChild(cspMeta);
      document.head.removeChild(referrerMeta);
      document.head.removeChild(contentTypeMeta);
      document.head.removeChild(permissionsMeta);
    };
  }, []);

  return null;
};
